// extracted by mini-css-extract-plugin
export var desktopLine = "pricingWave-module--desktop-line--1afe6";
export var leftpath = "pricingWave-module--leftpath--7bedb";
export var line = "pricingWave-module--line--2cb1d";
export var rightpath = "pricingWave-module--rightpath--d92f1";
export var ultrawideLine = "pricingWave-module--ultrawide-line--961a7";